<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const props = defineProps<{
  absolute?: boolean;
}>();

const isOpen = ref<boolean>(false);
</script>

<template>
  <v-dialog
    v-model="isOpen"
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="search-instructions__dialog"
  >
    <template #activator="{ props: activatorProps }">
      <v-tooltip :text="t('search.instructions.open')" location="top">
        <template #activator="{ props: tooltipActivatorProps }">
          <CloseBtn
            data-test-id="search-instructions-open-button"
            data-onboarding="search-instructions-open-button"
            v-bind="{ ...activatorProps, ...tooltipActivatorProps }"
            sentry-unmask
            class="search-instructions__open-btn"
            :class="{ 'search-instructions__open-btn--absolute': props.absolute }"
          >
            <v-icon>mdi-help-circle-outline</v-icon>
          </CloseBtn>
        </template>
      </v-tooltip>
    </template>
    <v-card data-onboarding="search-instructions-card">
      <!-- Close Button -->
      <CloseBtn
        sentry-unmask
        :aria-label="t('common.close')"
        class="v-card__close-btn"
        data-test-id="search-instructions-close"
        @click="isOpen = false"
      >
        <v-icon>mdi-close</v-icon>
      </CloseBtn>
      <v-card-title sentry-unmask>
        {{ t('search.instructions.title') }}
      </v-card-title>
      <v-card-text>
        <div v-html="t('search.instructions.description')" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.search-instructions {
  &__open-btn {
    &--absolute {
      position: absolute;
      right: 0;
    }
  }
}
</style>
